const values = {
  0: "sm:left-0",
  1: "sm:left-1",
  2: "sm:left-2",
  3: "sm:left-3",
  4: "sm:left-4",
  5: "sm:left-5",
  6: "sm:left-6",
  7: "sm:left-7",
  8: "sm:left-8",
  9: "sm:left-9",
  10: "sm:left-10",
  11: "sm:left-11",
  12: "sm:left-12",
  14: "sm:left-14",
  16: "sm:left-16",
  20: "sm:left-20",
  "1/2": "sm:left-1/2",
};

export default function getAbsoluteLeftSm(value) {
  return values[value];
}
